/**
 * AlmadarPostComplianceAsCodeSLPostPageView
 *
 * Functional component — logic + state-based JSX rendering.
 *
 * @generated from schema
 * @trait AlmadarPostComplianceAsCodeSLPostPage
 */

import { useAlmadarPostComplianceAsCodeSLPostPageLogic } from '@/hooks/traits/useAlmadarPostComplianceAsCodeSLPostPageLogic';
import type { AlmadarPostComplianceAsCodeSLPostPageConfig } from '@/hooks/traits/useAlmadarPostComplianceAsCodeSLPostPageLogic';
import type { EntityRow, EntityWith, EventPayload, EventPayloadValue, FieldValue } from '@almadar/core';
function getNestedValue(obj: EventPayload | EventPayloadValue | FieldValue | Record<string, FieldValue | undefined> | null | undefined, path: string): FieldValue | undefined {
  if (obj === null || obj === undefined || !path) return undefined;
  if (typeof obj !== 'object') return undefined;
  if (!path.includes('.') && !Array.isArray(obj)) {
    return (obj as Record<string, FieldValue | undefined>)[path];
  }
  let value: EventPayload | EventPayloadValue | FieldValue | Record<string, FieldValue | undefined> | null | undefined = obj;
  for (const part of path.split('.')) {
    if (value === null || value === undefined || typeof value !== 'object') return undefined;
    if (Array.isArray(value)) {
      if (!/^\d+$/.test(part)) return undefined;
      value = (value as readonly (EventPayloadValue | FieldValue | null | undefined)[])[Number(part)];
      continue;
    }
    value = (value as Record<string, FieldValue | undefined>)[part];
  }
  return value as FieldValue | undefined;
}
import type { AlmadarPostComplianceAsCodeSLPostView as AlmadarPostComplianceAsCodeSLPostViewEntity } from '@app/shared';
import { AlmadarPostComplianceAsCodeSLPostHeaderView } from '@/components/traits/AlmadarPostComplianceAsCodeSLPostHeaderView';
import { AlmadarPostComplianceAsCodeSLPostFooterView } from '@/components/traits/AlmadarPostComplianceAsCodeSLPostFooterView';
import { Stack } from '@almadar/ui/components';
import { Container } from '@almadar/ui/components';
import { Box } from '@almadar/ui/components';
import { AlmadarPostComplianceAsCodeSLPostView } from '@/components/traits/AlmadarPostComplianceAsCodeSLPostView';
import { UISlotComponent } from '@almadar/ui/components';
import { TraitScopeProvider } from '@almadar/ui/providers';

interface AlmadarPostComplianceAsCodeSLPostPageViewProps {
  config?: Partial<AlmadarPostComplianceAsCodeSLPostPageConfig>;
}

export function AlmadarPostComplianceAsCodeSLPostPageView({ config: propsConfig }: AlmadarPostComplianceAsCodeSLPostPageViewProps) {
  const { state, data, lastPayload, lastEvent, slotWriter, loading, pendingEvent, pendingFrom, error, fields, dispatch, actions, config } = useAlmadarPostComplianceAsCodeSLPostPageLogic(propsConfig);

  // Entity collection from server response data
  const entity: EntityRow[] = data['AlmadarPostComplianceAsCodeSLPostView'] ?? [];
  // Payload from last event (for @payload bindings in render-ui)
  const payload = lastPayload;

  return (
    <TraitScopeProvider orbital="AlmadarPostComplianceAsCodeSL" trait="AlmadarPostComplianceAsCodeSLPostPage">
      <UISlotComponent slot="main" pattern={slotWriter['main'] === 'INIT' ? "stack" : "clear"} sourceTrait="AlmadarPostComplianceAsCodeSLPostPage">{slotWriter['main'] === 'INIT' ? (<Stack gap="none" direction="vertical"><AlmadarPostComplianceAsCodeSLPostHeaderView config={{ entityId: propsConfig?.entityId, routeParams: propsConfig?.routeParams, initPayload: propsConfig?.initPayload }} /><Box fullWidth={true} paddingY="xl" bg="transparent"><Container maxWidth="xl" size="xl" padding="lg"><AlmadarPostComplianceAsCodeSLPostView config={{ entityId: propsConfig?.entityId, routeParams: propsConfig?.routeParams, initPayload: propsConfig?.initPayload }} /></Container></Box><AlmadarPostComplianceAsCodeSLPostFooterView config={{ entityId: propsConfig?.entityId, routeParams: propsConfig?.routeParams, initPayload: propsConfig?.initPayload }} /></Stack>) : null}</UISlotComponent>
    </TraitScopeProvider>
  );
}

export default AlmadarPostComplianceAsCodeSLPostPageView;
